<template>
  <div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>
    
  <app-hero-section :urlBackground="urlBackground" :herotype="herotype">
    <h1 style="color: #fff;" class="fs-48 fs-md-38 fs-sm-36 lh-9 lh-md-7 lh-sm-7 md-3 mb-6 mt-md-5 mt-sm-3 f-anti">Stop overpaying when sending money abroad</h1>
    <p class="fs-20 fs-sm-19 fw-demi-bold f-anti lh-4 mb-4 ls-1">Save on fees, obtain the best exchange rates and find the cheapest transfer provider with our real-time comparison engine.</p>

<p class="fs-20 fs-sm-19 fw-demi-bold f-anti lh-4 mb-4 ls-1">The result? More money arrives.</p>

    </app-hero-section> 

    <app-subhero-section class="pt-14 pb-7 pb-sm-3 mb-4">

      <widget-illustrations class="mb-9">
        <div class="title mb-5">
          <h2 class="fs-28 fs-md-25 fs-sm-24 lh-6 ls-sm-2 lh-sm-5 mt-5 mb-2 mb-sm-3">Monito is like a travel comparison site, but for money transfers</h2>
          <span class="fs-19 fs-md-17 fs-sm-17 italic fw-demi-bold f-anti" style="opacity: 0.88;">Compare. Select the best provider. Save money</span>
        </div>
        <div class="illustrations">
          <div class="fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 secure">We only recommend <span class="fw-bold">regulated and secure companies.</span></div>
          <div class="fs-17 fw-demi-bold f-anti ls-1 pt-7 pb-5 pl-3 pr-3 users">Our comparison engine is trusted by more than <span class="fw-bold">3 million users</span> worldwide.</div>
          <div class="fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 save"><span class="fw-bold">Save up to 90%</span> by choosing the cheapest provider today.</div>
        </div>
      </widget-illustrations>

      <widget-featured-on>
        
        <li><img src="public/forbes_logo.png"></li>
        <li><img src="public/guardian_logo.png"></li>
        <li><img src="public/business_insider_logo.png"></li>
        <li><img src="public/le_monde_logo.png"></li>
      </widget-featured-on>

    </app-subhero-section>

  </header>

  <widget-providers :providers="providers">
    <h1 class="fs-28 lh-6 mb-1 mt-5
      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2
    ">We compare and review over 300 money transfer companies</h1>
    <span class="fs-19 italic fs-sm-17 fw-demi-bold f-anti" style="opacity: 0.88;">An easy way to find the good one</span>
  </widget-providers>

  <main ref="main">
    <section ref="scroll_zone" class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8
      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
        <h1 class="f_title mt-3 mb-7 mt-2-sm mb-sm-6">Why compare international money transfer services?</h1>
        <p class="f_body">Sending money abroad could cost you a lot, especially if you aren’t aware of the hidden fees. Money transfer companies and banks earn money by not only charging you a transfer fee, but also usually by offering you an exchange rate with a hidden markup.</p> 
        <p class="f_body">You could save a lot of money by comparing exchange rates and transfer fees in real-time. With our money transfer comparison tool, you’ll find the best way to send money internationally in just a few clicks.</p>
        <img src="https://images.prismic.io/monito/0a0d2c4639f1cb8342c63080595b2a4242c2a5ef_bar-chart-transfer-to-india-homepage-english.png" class="mt-6 mt-6-sm"/>
        
        <h2 class="f_subtitle_1">Everyone wins, except expensive solutions</h2>
        <p class="f_body">With our model, the only losers are the expensive banks or providers you’ll stop using! To ensure our independence, we always use transparent, objective and verifiable criteria in our comparison. No provider can buy their way to the top of our results.</p>
        <p class="f_body">We include as many providers as possible in our comparison and have partnerships with almost all major and innovative providers.</p>
        <p class="f_body">We make sure you never pay more than if you went directly to the provider of your choice. We even negotiate special offers for you with many of our partners.</p>
       
    </section>

    <aside ref="scroll_widgets" class="scroller"><monito-widgets-imt-search-form powered-by-nf="off" country-from="US" country-to="PH"></monito-widgets-imt-search-form></aside>

   
  </main>
    
  <widget-faq>
    <h1 class="fs-28 fw-bold f-anti mb-9">Questions you may have</h1>
      <ul class="shadow">
        <li>
          <h3>How can I use Monito to find the best ways to send money?</h3>
          <p class="f_body">Before you make an international money transfer, compare the costs of the different options on <a href="https://www.monito.com/en/?utm_source=google&amp;utm_medium=Organic&amp;utm_campaign=FAQ&amp;utm_term=Homepage_EN">Monito</a>. Rates and fees change often, so for the best deal, do a comparison before every transfer — they may have changed since you last sent money. Once you enter the details about where you are sending money from and to, click on compare. You’ll see a list of all the options to send money between two countries. The best option is at the top, but you may want to consider other criteria such as the speed of transaction or the pay-in or payout methods.</p>
        </li>
        <li>
          <h3>I simply use my bank to send money abroad, do I really need to compare other options?</h3>
          <p class="f_body">Of course! Banks are usually not the best way to make international money transfers. The fees can be quite low (sometimes even zero), but banks often apply a markup on the exchange rates, a high hidden fee that you can avoid by <a href="https://www.monito.com/en/?utm_source=google&amp;utm_medium=Organic&amp;utm_campaign=FAQ&amp;utm_term=Homepage_EN">finding better options on Monito</a>. We list as many banks as possible in our results, so you can  compare and find out if you’d be better off switching to another bank or a specialized money transfer company.</p>
        </li>
        <li>
          <h3>Can I trust a company I found on Monito but have never heard about before?</h3>
          <p class="f_body">We review money transfer companies and give them a Monito Score, which includes a Credibility and Security component. You can find if a money transfer company is reputable and trustworthy in our comparison results or <a target="_blank" rel="noopener" href="https://www.monito.com/en/money-transfer-services?utm_source=google&amp;utm_medium=Organic&amp;utm_campaign=FAQ&amp;utm_term=Moneygram_EN">on a company's review page</a>. A general rule is that we only list money transfer operators or banks that are fully authorized and monitored by the regulatory authorities of their operating countries.</p>
        </li>
        <li>
          <h3>Is it possible to send money with Monito, or are you just a service to compare money transfer services?</h3>
          <p class="f_body"><a href="https://www.monito.com/en/?utm_source=google&amp;utm_medium=Organic&amp;utm_campaign=FAQ&amp;utm_term=Homepage_EN">Monito </a>is not a money transfer company. We’re here to help you <a href="https://www.monito.com/en/?utm_source=google&amp;utm_medium=Organic&amp;utm_campaign=FAQ&amp;utm_term=Homepage_EN">find the best way to send money abroad</a>. Just tell us which country you’re sending money from and which country you want to send money to, and we’ll show you a list of all available services. Once you select the best one for your needs, you'll be redirected to the money transfer provider’s website to get started with your transfer.</p>
        </li>
        
      </ul>
  </widget-faq>
  <widget-articles :articles="articles"><h1 class="fs-28 fw-bold f-anti mb-9">This might interest you too</h1></widget-articles>
  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetIllustrations from './WidgetIllustrations.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
    data() {
      return {
        herotype :'home',
        urlBackground :'',
        providers : [
          {logo: 'public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: 'public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: 'public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: 'public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: 'public/review_transfergo.png',url:'paypal.com',score:'8.2'},
          {logo: 'public/review_western.png',url:'paypal.com',score:'7.9'},
          {logo: 'public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: 'public/review_xendpay.png',url:'paypal.com',score:'6.6'},
          {logo: 'public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad',
            title:'Find the Cheapest Way to Send Money Abroad',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
            url:'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives',
            title:'Can I use Zelle to send money Internationally? No! Find alternatives now',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/prismic/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
            title:'Find the Fastest Way to Send Money Abroad',
            date_author:'Nov. 14, 2019'},
          
          

          { cover: '',
            url:'https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives',
            title:'Can I use Square Cash to send money Internationally?',
            date_author:'Oct. 01, 2019'},
          
          { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018  -  by Caroline Sieg'}
          
         

        ]
      }
    },
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,

      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.main.clientHeight,


      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);


      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

   
        if(y > (position_x_aside - 20)){
          if(y <= (bottom_main_content - aside_height - 20)){
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '0px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
  
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor,
      'widget-illustrations' : WidgetIllustrations
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">

  main {
    position: relative;
    z-index: 10000;
  }

  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
  }

  @media ($tablet_portrait) {
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      h1 {
        text-align: center;
      }
    }
    .scroller {
      display: none;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Home_old.vue